import { IntlShape } from "react-intl";

import { NotifyPartySyncOption } from "pages/shipper/RequestFormV2/defaults/notifyPartyDefaults";

export function getNotifyPartySyncOptions(intl: IntlShape): { label: string; value: NotifyPartySyncOption }[] {
  return [
    {
      label: intl.formatMessage({
        id: "new-request.schedule.notifyParty.customAddressContact",
        defaultMessage: "Custom address & contact",
      }),
      value: "customAddressContact",
    },
    {
      label: intl.formatMessage({
        id: "new-request.schedule.sameAsConsigneeAddressContact",
        defaultMessage: "Same as consignee address & consignee contact",
      }),
      value: "sameAsConsigneeAddressContact",
    },
    {
      label: intl.formatMessage({
        id: "new-request.schedule.sameAsDeliveryAddressContact",
        defaultMessage: "Same as delivery address & delivery contact",
      }),
      value: "sameAsDeliveryAddressContact",
    },
  ];
}
